<template>
  <v-popup v-model="show" :overlay="false" style="width: 100%; height: 100%; z-index: 3005 !important">
    <div :class="[bem(), className, env.isBankabc ? 'bankabc' : '']" :style="bgStyle || backgroundColor" :key="theKey">
      <div v-if="showIndex" :class="bem('index')" :style="indexColor">
        <div class="shadow"></div>
        <template v-if="counter">
          {{ counter }}
        </template>
        <span v-else class="fs-48">{{ active + 1 }}/{{ count }}</span>
      </div>

      <div v-if="closeable" :class="bem('close')" @touchend="onTouchClose" :style="{ marginTop: `${nativeHeight}px` }">
        <span :class="[bem('icon'), this.theme]"></span>
      </div>
      <div class="image-preview-over" :style="imageOverlay">
        <swiper
          :class="bem('swipe')"
          ref="vswiper"
          :options="swiperOption"
          @touchStart="touchStart"
          @touchEnd="touchEnd"
        >
          <swiper-slide v-for="(item, index) in imgList" :key="index">
            <div :class="bem('swipewrap')" @click="onZoomDoubleTap()">
              <video-detail
                ref="myVideo"
                :infoVideoOptions="infoVideoOptions(item)"
                v-if="item.videoUrl"
                :playerId="index"
              ></video-detail>
              <img :class="bem('image')" :src="item" v-else />
            </div>
          </swiper-slide>
          <!--释放查看详情-->
          <v-slide-more v-if="slideMore" />
        </swiper>
      </div>
      <transition name="v-fade" v-if="!(imgList.length && imgList[0].videoUrl) || active != 0">
        <slot v-if="showSlot"></slot>
      </transition>
    </div>
  </v-popup>
</template>

<script>
import create from '../create'
import PinchZoom from '@/assets/js/lib/pinch-zoom'
import 'swiper/dist/css/swiper.css'
import env from 'utils/clientEnv'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import videoDetail from '../video'
import SlideMore from '../slide-more'
import { app } from '@/utils'

export default create({
  name: 'image-preview',

  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide,
    videoDetail,
    'v-slide-more': SlideMore
  },

  props: {
    show: {
      type: Boolean
    },
    images: [String, Array],
    startPosition: {
      type: Number,
      default: 0
    },
    showIndicators: Boolean,
    className: [String, Object, Array],
    onClose: Function,
    closeable: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      validator: v => ['white', 'black'].includes(v),
      default: 'white'
    },
    showIndex: {
      type: Boolean,
      default: true
    },
    maxZoom: {
      type: Number,
      default: 2.5
    },
    theKey: {
      type: [String, Number],
      default: 'image-preview'
    },
    counter: {
      type: String,
      default: ''
    },
    // 传入进来的背景样式
    bgStyle: {
      type: Object,
      default() {
        return null
      }
    },
    containerStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    // 是否有滑动查看更多
    slideMore: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      env,
      showSlot: true,
      active: this.startPosition,
      lastPerIndx: 0, // 上一次swiper index，用于判断是否是最后一页滑动
      startClientX: 0, // 滑动开始位移
      endClientXAbs: 0, // 滑动位移差，用于判断左滑还是右滑
      isPreShow: false, // 是否重新展示
      translate: 0, // 滑动位置
      nativeHeight: 0 // iOS沉浸式顶部高度
    }
  },
  computed: {
    swiperOption() {
      let self = this
      return {
        initialSlide: this.active,
        lazy: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        on: {
          slideChange: function () {
            // 视频划走暂停，划入播放
            // if (this.activeIndex == 0) {
            //   self.$refs.myVideo[0] && self.$refs.myVideo[0].playVideo()
            // } else {
            //   self.$refs.myVideo[0] && self.$refs.myVideo[0].pauseVideo()
            // }

            self.active = this.activeIndex
            if (!self.isPreShow) {
              self.$emit('refreshPreviewSlide', self.active)
            }
            self.isPreShow = false
          },
          touchStart: function (e) {
            self.startClientX = e.touches[0].clientX
          },
          touchMove: function (e) {
            self.endClientXAbs = e.touches[0].clientX - self.startClientX
          },
          transitionEnd: function () {
            // 预览前一条评论
            if (this.isBeginning && this.activeIndex == self.lastPerIndx && self.endClientXAbs > 0) {
              self.$emit('previewToBegin')
            }
            // 预览后一条评论
            if (this.isEnd && this.activeIndex == self.lastPerIndx && self.endClientXAbs < 0) {
              self.$emit('previewToEnd')
            }
            self.lastPerIndx = this.activeIndex
          },
          // 图片双击放大
          init: function () {
            self.initPinchZoom()
          }
        }
      }
    },
    swiper() {
      return this.$refs.vswiper.swiper
    },
    imgList() {
      var list = []
      if (typeof this.images === 'string') {
        list.push(this.images)
      } else {
        list = this.images
      }
      return list
    },
    backgroundColor() {
      return {
        backgroundColor: this.theme
      }
    },
    indexColor() {
      return {
        color: this.theme === 'black' ? 'white' : 'black',
        marginTop: `${this.nativeHeight}px`
      }
    },
    count() {
      return typeof this.images === 'string' ? 1 : this.images.length
    },
    imageOverlay() {
      if (this.bgStyle) {
        return {
          backgroundColor: 'rgba(255, 255, 255, 0.7)'
        }
      } else {
        return ''
      }
    }
  },

  watch: {
    startPosition(active) {
      this.active = active
    },
    show(data) {
      if (!data) {
        return
      }
      this.isPreShow = true
      // 显示的时候，从传入的索引开始
      this.$nextTick(() => {
        this.showSlot = true
        this.$refs.vswiper && this.$refs.vswiper.swiper.slideTo(this.startPosition, 0)
        this.isPreShow = false
        this.initPinchZoom()
        // 解决IOS下-webkit-overflow-scrolling导致z-index失效的问题
        if (env.isIOS) {
          let type = data ? 'auto' : 'touch'
          document.querySelector('.v-page__container>.container') &&
            document
              .querySelector('.v-page__container>.container')
              .setAttribute('style', '-webkit-overflow-scrolling: ' + type)
        }
      })
    }
  },

  created() {
    if (env.isIOSVivoApp) {
      this.getNativeHeight()
    }
  },

  methods: {
    getNativeHeight() {
      app.getTitleBarHeight({
        type: 'statusBarHeight',
        success: res => {
          this.nativeHeight = res
        }
      })
    },
    onZoomDoubleTap(isShow) {
      this.showSlot = isShow == undefined ? !this.showSlot : isShow
    },
    onTouchClose(event) {
      event && event.stopPropagation()
      event && event.preventDefault()
      this.isPreShow = true
      this.onClose &&
        this.onClose({
          index: this.active,
          url: this.images[this.active]
        })
    },
    // 切换评论重置swiper
    refreshPreview(pos) {
      this.$emit('refreshPreviewSlide', pos)
      this.isPreShow = true
      this.$nextTick(() => {
        this.$refs.vswiper.swiper.update()
        this.$refs.vswiper.swiper.slideTo(pos, 0, false)
        this.isPreShow = false
        this.initPinchZoom()
      })
    },
    // 初始化图片放大组件
    initPinchZoom() {
      let wraps = document.getElementsByClassName('v-image-preview__swipewrap')
      if (wraps && wraps.length) {
        let item
        for (let i = 0; i < wraps.length; i++) {
          item = wraps[i]
          item.addEventListener('pz_unzoom', () => {
            this.onZoomDoubleTap(true)
          })
          item.addEventListener('pz_zoomed', () => {
            this.onZoomDoubleTap(false)
          })
          this.pinchZoom = new PinchZoom(item, {
            maxZoom: this.maxZoom
          })
        }
      }
    },
    // 视频播放信息
    infoVideoOptions(item) {
      let videoOptions = {
        videoSrc: item.videoUrl,
        videoPoster: item.videoPoster,
        videoType: 'video/mp4'
      }
      return videoOptions
    },
    /**
     * 滑动开始事件，记录位置
     */
    touchStart() {
      this.translate = this.swiper.getTranslate()
    },
    /**
     * 滑动结束后执行
     */
    touchEnd() {
      let self = this
      if (self.slideMore) {
        let move = self.swiper.translate - self.translate
        if (self.swiper.isEnd && move < -80) {
          self.onTouchClose()
          self.$nextTick(() => {
            self.$emit('slideAction')
          })
        }
      }
    }
  }
})
</script>
<style scoped lang="scss" src="./index.scss"></style>
